import React from 'react';
import type { ContentPack } from '../../packs/types';

interface CanvasStageProps {
  stageRef: React.RefObject<HTMLDivElement | null>;
  canvasRef: React.RefObject<HTMLCanvasElement | null>;
  pack: ContentPack;
  side: number;
}

export function CanvasStage({ stageRef, canvasRef, pack, side }: CanvasStageProps) {
  return (
    <div
      ref={stageRef}
      className="w-full shrink-0 flex items-center justify-center relative"
      style={{ height: 'clamp(220px, 42vh, 380px)', background: 'var(--bg)' }}
    >
      <canvas
        ref={canvasRef}
        width={pack.rasterSize}
        height={pack.rasterSize}
        style={{ width: side, height: side, imageRendering: 'pixelated' }}
      />
      <div
        className="absolute bottom-0 left-0 right-0 pointer-events-none"
        style={{ height: 40, background: 'linear-gradient(to bottom, transparent, #0f172a)' }}
      />
    </div>
  );
}
